export default {
    url: '',
    template: '<manage-permissions-companies-list/>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/permissions/companies/list/index.js